import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  banner: {
    marginBottom: "24px",
    '& .MuiAlert-message': {
      width: '100%',
    },
  },
});
